var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6829",
    "data-name": "Group 6829",
    transform: "translate(-310 -252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_75",
    "data-name": "Union 75",
    d: "M4315,5388.5a1.5,1.5,0,0,1,1.061.439l2.439,2.439,2.439-2.439a1.5,1.5,0,1,1,2.121,2.121l-2.439,2.439,2.439,2.439a1.5,1.5,0,0,1-2.121,2.121l-2.439-2.439-2.439,2.439a1.5,1.5,0,1,1-2.121-2.121l2.439-2.439-2.439-2.439A1.5,1.5,0,0,1,4315,5388.5Z",
    transform: "translate(-4003.5 -5136.5)",
    fill: "#3d3a4b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseAlertIcon);
export default __webpack_public_path__ + "static/media/close-alert-icon.73332e48.svg";
export { ForwardRef as ReactComponent };